export default __webpack_public_path__ + "static/media/icon2.32c44862.png";